/* globals Events */

window['events#new'] = function () {
  Events.init()
}
